import { PropsWithChildren } from 'react';

import * as Sentry from '@sentry/react';

import { FullPageErrorFallback, PartialErrorFallback } from '../error-fallbacks';

export const fallbacks = {
  full: FullPageErrorFallback,
  partial: PartialErrorFallback,
};

export type FallbackType = keyof typeof fallbacks;

type ErrorBoundaryProps = {
  name: string;
  fallbackType?: FallbackType;
};

export const ErrorBoundary: React.FC<PropsWithChildren<ErrorBoundaryProps>> = ({
  name,
  fallbackType = 'partial',
  children,
}) => (
  <Sentry.ErrorBoundary fallback={fallbacks[fallbackType]} beforeCapture={scope => scope.setTransactionName(name)}>
    {children}
  </Sentry.ErrorBoundary>
);
